import React, { useState } from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { MdClose } from "react-icons/md";
import Chart from "react-apexcharts";
import "./Cards.css";
import { cardsData } from "../../Data/Data";

// Compact Card
function CompactCard({ param, setExpanded }) {
  const Png = param.png;
  return (
    <div
      className="CompactCard"
      style={{
        background: param.color.backGround,
        boxShadow: param.color.boxShadow,
      }}
      onClick={setExpanded}
    >
      <div className="radialBar">
        <CircularProgressbar
          value={param.barValue}
          text={`${param.barValue}%`}
          background={param.barValue <= 10 ? true : false}
          styles={buildStyles({ backgroundColor: "#FF9999",
        })}
        />
        <span>{param.title}</span>
      </div>
      <div className="detail  flex flex-row">
        <Png size={20} />
        <span>{param.value}</span>
        <span> {param.updated_at}</span>
      </div>
    </div>
  );
}

// Expanded Card
function ExpandedCard({ param, setExpanded }) {
  setExpanded = setExpanded || false;
  const data = {
    options: {
      chart: {
        type: "area",
        height: "auto",
      },

      dropShadow: {
        enabled: false,
        enabledOnSeries: undefined,
        top: 0,
        left: 0,
        blur: 3,
        color: "#000",
        opacity: 0.35,
      },

      fill: {
        colors: ["#fff"],
        type: "gradient",
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        colors: ["white"],
      },
      tooltip: {
        x: {
          format: "dd/MM/yy HH:mm",
        },
      },
      grid: {
        show: true,
      },
      xaxis: {
        type: "datetime",
        categories: [
          "2018-09-19T00:00:00.000Z",
          "2018-09-19T01:30:00.000Z",
          "2018-09-19T02:30:00.000Z",
          "2018-09-19T03:30:00.000Z",
          "2018-09-19T04:30:00.000Z",
          "2018-09-19T05:30:00.000Z",
          "2018-09-19T06:30:00.000Z",
        ],
      },
    },
  };

  return (
    <div
      className="ExpandedCard"
      style={{
        background: param.color.backGround,
        boxShadow: param.color.boxShadow,
      }}
    >
      <div style={{ alignSelf: "flex-end", cursor: "pointer", color: "white" }}>
        <MdClose onClick={setExpanded} />
      </div>
      <span>{param.title}</span>
      <div className="chartContainer">
        <Chart options={data.options} series={param.series} type="area" />
      </div>
      <span>Last Ping Cycle {data.updated_at}</span>
    </div>
  );
}

const Card = (props) => {
  const [expanded, setExpanded] = useState(false);
  return expanded ? (
    <ExpandedCard param={props} setExpanded={() => setExpanded(false)} />
  ) : (
    <CompactCard param={props} setExpanded={() => setExpanded(false)} />
  );
};

const Cards = ({ gwData }) => {
  //console.log("card gwdata", gwData);
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-5  space-x-2 space-y-2">
      {cardsData.map((card, id) => {
        return (
          <div className="h-30" key={id}>
            <Card
              title={card.title}
              color={card.color}
              barValue={gwData ? gwData[card.id] : card.barValue}
              value={card.value}
              png={card.png}
              series={card.series}
              updated_at={gwData ? gwData.updated_at : "00:00"}
            />
          </div>
        );
      })}
    </div>
  );
};

export default Cards;
